<div class="email-inbox">
    <div class="header">
        <div class="title">
            <div class="text">RE: Template Preview In Email Client</div>
            <div class="tag">
                <span class="text" trans>Inbox</span>
                <mat-icon svgIcon="close"></mat-icon>
            </div>
        </div>
        <div class="actions">
            <mat-icon svgIcon="print"></mat-icon>
            <mat-icon svgIcon="open-in-new"></mat-icon>
        </div>
    </div>
    <div class="toolbar">
        <div class="user">
            <img src="https://www.gravatar.com/avatar/abc?s=65">
            <div class="meta">
                <div class="username">John Doe</div>
                <div class="info">
                    <span trans>to me</span>
                    <mat-icon svgIcon="keyboard-arrow-down"></mat-icon>
                </div>
            </div>
        </div>
        <div class="actions">
            <div class="date">June 25</div>
            <mat-icon svgIcon="star-border" class="star-icon"></mat-icon>
            <div class="buttons">
                <div class="reply">
                    <mat-icon svgIcon="reply"></mat-icon>
                </div>
                <div class="more">
                    <mat-icon svgIcon="keyboard-arrow-down"></mat-icon>
                </div>
            </div>
        </div>
    </div>
</div>

<iframe src="about:blank" #iframe></iframe>

<loading-indicator class="overlay" [isVisible]="loading"></loading-indicator>